<template>
  <v-dialog persistent v-model="dialog" max-width="500">
    <v-card v-if="telefone">
      <v-card-title>
        {{ titulo }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="telefone.numero"
          v-touch="telefone.numero"
          v-mask="'phone'"
          label="Número"
          :error-messages="numeroErrors"
          maxlength="15"
        />
        <v-switch label="Telefone principal" v-model="telefone.principal" />
        <v-text-field
          v-model="telefone.nome"
          v-touch="telefone.nome"
          label="Identificação do telefone"
          :error-messages="nomeErrors"
          counter="40"
        />
        <v-row justify="space-around">
          <v-checkbox v-model="telefone.celular" label="Celular" />
          <v-checkbox v-model="telefone.whatsapp" label="Whatsapp" />
          <v-checkbox v-model="telefone.telegram" label="Telegram" />
        </v-row>
        <v-textarea
          auto-grow
          rows="2"
          v-model="telefone.descricao"
          v-touch="telefone.descricao"
          label="Descrição"
          :error-messages="descricaoErrors"
          counter="140"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn class="primary" depressed :disabled="$v.$invalid" @click="salvar()">{{ tituloBotao }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { unmaskPhone } from "../../lib/masks";

export default {
  mixins: [validationMixin],
  validations: {
    telefone: {
      numero: { required, maxLength: maxLength(20) },
      nome: { maxLength: maxLength(40) },
      descricao: { maxLength: maxLength(140) }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.contato.telefoneAtivo;
      },
      set(open) {
        if (!open) {
          this.$store.commit("contato/limparTelefoneAtivo");
        }
      }
    },
    titulo() {
      return this.telefone.id ? "Editar telefone" : "Novo telefone";
    },
    tituloBotao() {
      return this.telefone.id ? "Editar" : "Adicionar";
    },
    numeroErrors() {
      const errors = [];
      if (!this.$v.telefone.numero.$dirty) return errors;
      !this.$v.telefone.numero.required && errors.push("Informe o telefone");
      !this.$v.telefone.numero.maxLength &&
        errors.push("Somente 20 caracteres");
      return errors;
    },
    nomeErrors() {
      const errors = [];
      if (!this.$v.telefone.nome.$dirty) return errors;
      !this.$v.telefone.nome.maxLength && errors.push("Somente 40 caracteres");
      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.telefone.descricao.$dirty) return errors;
      !this.$v.telefone.descricao.maxLength &&
        errors.push("Somente 140 caracteres");
      return errors;
    },
    telefone: {
      get() {
        return this.$store.state.contato.telefoneAtivo;
      },
      set(telefone) {
        this.$store.commit("contato/editarTelefone", telefone);
      }
    }
  },
  methods: {
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const telefone = _.cloneDeep(this.telefone);
        telefone.numero = unmaskPhone(telefone.numero);
        telefone.novo = telefone.novo || !telefone.id;
        telefone.editar = !telefone.novo && telefone.id !== "";
        this.$emit("change", telefone);
        this.dialog = false;
      }
    }
  }
};
</script>
